import * as uuid from 'uuid'

export function getUriFactory(baseUri) {
  if (!baseUri) {
    throw new Error('Configuration Error: baseUri was empty or not provided')
  }
  if (baseUri.endsWith('/')) {
    baseUri = baseUri.slice(0, baseUri.length - 1)
  }

  return uriFragment => {
    if (!uriFragment.startsWith('/')) {
      uriFragment = '/' + uriFragment
    }

    return baseUri + uriFragment
  }
}

export function getHeadersFactory(
  accessTokenOrGetter,
  { originatorApp = null } = {}
) {
  const createLoggingContext = () => {
    const Guid = uuid.v1()
    const OriginatorUtcTimestamp = new Date().toUTCString()

    const correlationHeader = {
      CallChainId: Guid,
      OriginatorUtcTimestamp: OriginatorUtcTimestamp,
      ExtraHeaders: {
        OriginatorApp: originatorApp
      }
    }

    return btoa(JSON.stringify(correlationHeader))
  }

  async function getToken() {
    if (typeof accessTokenOrGetter === 'function') {
      return await accessTokenOrGetter()
    }

    return accessTokenOrGetter
  }

  return async () => ({
    'Authorization': 'Bearer ' + (await getToken()),
    'zametek-utility-trackingcontext': createLoggingContext()
  })
}
